import styled, { css } from '@xstyled/styled-components'

const commonStyles = css({
  height: 40,
  width: '100%',
  position: 'relative',
  boxSizing: 'border-box'
})

export const StyledWaveformScrubber = styled.div(
  {
    cursor: 'pointer',
    '&[data-disabled]': {
      opacity: 0.6,
      cursor: 'default',
      pointerEvents: 'none'
    }
  },
  commonStyles
)

export const StyledWaveformScrubberSkeleton = styled.div(
  {
    cursor: 'default'
  },
  commonStyles
)

export const WaveformScrubberTrack = styled.div({
  alignItems: 'center',
  display: 'flex',
  width: '100%',
  height: '40px',
  overflow: 'hidden',
  boxSizing: 'border-box'
})

export const WaveformScrubberElapsed = styled.div({
  position: 'absolute',
  overflow: 'hidden',
  height: 'inherit',
  boxSizing: 'border-box'
})

export const WaveformScrubberThumb = styled.div(
  {
    position: 'absolute',
    top: '50%',
    height: '100%',
    width: '3px',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    zIndex: 1,
    borderRadius: '6px',
    background: 'transparent',
    transform: 'translateY(-50%)'
  },
  props => ({
    '&[data-focus]': {
      boxShadow: props.theme.shadows['outline-primary']
    }
  }),
  props => ({
    '&[data-disabled]': {
      background: props.theme.colors.disabled.l1
    }
  })
)
